import { useQuery } from 'react-query';
import * as peApi from '../pe.api';

const useWorkspaceStatistics = (workspaceId: number) =>
  useQuery(['workspace-statistics', workspaceId], () => peApi.getWorkspaceStatistics(), {
    cacheTime: 0,
  });

export default useWorkspaceStatistics;
